import React from 'react';

interface MetricCardProps {
  title: string;
  value?: string;
  valueNode?: React.ReactNode;
  icon: React.ReactNode;
  trend?: 'up' | 'down' | 'neutral';
  description?: string;
}

const getTrendColor = (trend?: MetricCardProps['trend']): string => {
  switch (trend) {
    case 'up':
      return 'text-green-600';
    case 'down':
      return 'text-red-600';
    default:
      return 'text-gray-600';
  }
};

export const MetricCard: React.FC<MetricCardProps> = ({ title, value = '', valueNode, icon, trend, description }) => {
  const trendColor = getTrendColor(trend);

  return (
    <div className="bg-white rounded-lg shadow p-6">
      <div className="flex items-center justify-between">
        <div>
          <p className="text-sm text-gray-600">{title}</p>
          {valueNode ? (
            <div className={`text-2xl font-bold ${trendColor} leading-snug`}>{valueNode}</div>
          ) : (
            <p className={`text-2xl font-bold ${trendColor}`}>{value}</p>
          )}
          {description && <p className="text-xs text-gray-500 mt-1">{description}</p>}
        </div>
        <div className={trendColor}>{icon}</div>
      </div>
    </div>
  );
};
